/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaSearch, FaTimes, FaArrowDown, FaArrowUp } from "react-icons/fa";
import { CustomTable } from "../../components/Table";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fontsource/source-sans-pro";
import useToaster from "../../hooks/useToaster";
import { useSelector } from "react-redux";
import {
  fetchUserForForm,
  fetchUsersTaskPermission,
} from "../../services/apiService/userApi";
import AssignmentModal from "../../components/ui/AssignmentModel";
import NoArticle from "../../assets/article.png";
import NoIssues from "../../assets/book.png";
import { useNavigate } from "react-router-dom";
import FilterChips from "../../components/ui/FilterChip";
import {
  fetchArticleByUnAssigned,
  fetchVolIss,
  updateTaskArticle,
} from "../../services/apiService/articleApi";
import Pagination from "../../components/ui/Pagination";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../components/ui/Popover";
import DropdownCheckbox from "../../components/ui/DropdownCheck";
import SortDropdown from "../../components/ui/DropdownSort";
import {
  MdOutlineFilterAlt,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import {
  fetchIssueById,
  fetchIssueByUnAssigned,
  updateTaskIssue,
} from "../../services/apiService/issueApi";
import dayjs from "dayjs";
import { PageSkeletons, Spinner } from "../../components/ui/Skeleton";
import { fetchJournals } from "../../services/apiService/journalApi";
import DynamicFilterPopover from "../../components/ui/DynamicFilterPopover";
import IssueDetails from "../../components/forms/NewIssueForm";
import ArticleForm from "../../components/forms/JournalOverviewForm";
import DataSyncError from "../../components/edgeCases/DataSyncError";

const TaskAssignmentPage = ({ active, setIsReload }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [articleUsers, setArticleUsers] = useState([]);
  const [issueUsers, setIssueUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isJournalFilterOpen, setIsJournalFilterOpen] = useState(false);
  const [isAdditionalFilterOpen, setIsAdditionalFilterOpen] = useState(false);
  const [showVolIssOptions, setShowVolIssOptions] = useState(false);
  const [articles, setArticles] = useState([]);
  const [issues, setIssues] = useState([]);
  const [issueCursor, setIssueCursor] = useState(null);
  const [prevCursor, setPrevCursor] = useState(null);
  const [direction, setDirection] = useState("forward");
  const [articlePagination, setArticlePagination] = useState({
    page: 1,
    limit: 100,
    totalItems: 0,
    totalPages: 1,
  });
  const [issuePagination, setIssuePagination] = useState({
    page: 1,
    limit: 100,
    totalItems: 0,
    totalPages: 1,
  });
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [hasTasks, setHasTasks] = useState(true);
  const [totalArticle, setTotalArticle] = useState(0);
  const [totalIssue, setTotalIssue] = useState(0);
  const [loadingState, setLoadingState] = useState("spinning");
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [activeRowId, setActiveRowId] = useState(null);
  const [hasFilters, setHasFilters] = useState(false);
  const [isLoadingIssues, setIsLoadingIssues] = useState(false);
  const [isLoadingArticles, setIsLoadingArticles] = useState(false);

  let [journalOptions, setJournalOptions] = useState([]);
  let [IssueJournalOptions, setIssueJournalOptions] = useState([]);

  let [volIssOptions, setVolIssOptions] = useState([]);
  let [IssueVolIssOptions, setIssueVolIssOptions] = useState([]);

  let [articleTypesOptions, setArticleTypesOptions] = useState([]);
  let [productionWorkflowOptions, setProductionWorkflowOptions] = useState([]);
  const [articleTypeOpen, setArticleTypeOpen] = useState(false);
  const [productionWorkflowOpen, setProductionWorkflowOpen] = useState(false);
  const [selectedFieldConfig, setSelectedFieldConfiguration] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [objectUserOption, setObjectUserOption] = useState([]);

  let [pointsOptions, setPointsOptions] = useState([]);
  let [openForm, setOpenForm] = useState(false);

  const searchTriggeredRef = useRef(false);
  const sortEffectRanRef = useRef(false);

  const scrollContainerRef = useRef(null);
  const [articleFilters, setArticleFilters] = useState({
    searchQuery: "",
    selectedJournals: ["All"],
    selectedVolIss: ["All"],
    articleTypes: ["All"],
    copyediting: ["All"],
    tempArticleTypes: ["All"],
    tempCopyediting: ["All"],
    selectedJournalIds: [],
    tempSelectedJournals: ["All"],
    preAccepted: false,
    tempPreAccepted: false,
    sceReturnedStatus: "",
    tempSceReturnedStatus: "",
    itemHoldout: "",
    tempItemHoldout: "",
    points: ["All"],
    tempPoints: ["All"],
  });
  const [issueFilters, setIssueFilters] = useState({
    searchQuery: "",
    selectedJournals: ["All"],
    selectedVolIss: ["All"],
    task: [],
    tempTask: [],
    selectedJournalIds: [],
    tempSelectedJournals: ["All"],
  });

  const { userData, preferences, dataSyncTime } = useSelector(
    (state) => state.user
  );

  let isArticle = userData.articleTaskManagement !== "None";
  let isIssue = userData.issueTaskManagement !== "None";
  const [activeTab, setActiveTab] = useState(
    isArticle ? "Article" : isIssue ? "Issue" : "Article"
  );
  const activeTabRef = useRef(activeTab);
  const showToast = useToaster();
  const navigate = useNavigate();

  const ArticleHeaders = [
    { key: "journalInfo?.journalName", value: "JOURNAL" },
    {
      key: "pts",
      value: "PTS#",
      onClick: onRowSelect,
      style: { cursor: "pointer" },
    },
    { key: "docHead", value: "DOCHEAD" },
    { key: "productionWorkflow", value: "PROD WF" },
    { key: "points", value: "POINTS" },
    { key: "acceptedDate", value: "ACCEPTED" },
    { key: "itemHoldout", value: "HOLDOUT" },
    { key: "speedTarget", value: "SPEED TARGET" },
    { key: "sceReturnedStatus", value: "SCE BACK" },
    { key: "pressRelease", value: "PR" },
    { key: "ptsRefersTo", value: "REFERS TO" },
    { key: "journalInfo?.team", value: "TEAM" },
  ];

  let IssueHeaders = [
    { key: "journal", value: "JOURNAL" },
    {
      key: "volIss",
      value: "VOL/ISS",
      onClick: onRowSelect,
      style: { cursor: "pointer" },
    },
    { key: "task", value: "TASK" },
    { key: "team", value: "TEAM" },
    { key: "taskDueDate", value: "DUE DATE" },
  ];

  useEffect(() => {
    activeTabRef.current = activeTab;
  }, [activeTab]);

  let hasTasksValue = false;

  useEffect(() => {
    hasTasksValue =
      activeTab === "Article" ? articles.length > 0 : issues.length > 0;
    setHasTasks(hasTasksValue);
  }, [activeTab, articles, issues]);

  // for showing loading at initial loading
  const showInitialLoading = useMemo(() => {
    if (activeTab === "Article") {
      return articles.length === 0 && isLoadingArticles;
    }
    return issues.length === 0 && isLoadingIssues;
  }, [issues, articles, isLoadingArticles, isLoadingIssues]);

  // search query
  const searchQuery = articleFilters.searchQuery || issueFilters.searchQuery;

  const fetchArticlesData = useCallback(async () => {
    try {
      setIsLoadingArticles(true);
      const response = await fetchArticleByUnAssigned({
        page: articlePagination.page,
        limit: articlePagination.limit,
        search: articleFilters.searchQuery.trim(),
        journal: articleFilters.selectedJournalIds,
        docHead: articleFilters.articleTypes,
        copyedit: articleFilters.copyediting,
        volIss: articleFilters.selectedVolIss,
        key: sortConfig.key,
        direction: sortConfig.direction,
        userId: userData.id,
        points: articleFilters.points,
        preAccept: articleFilters.preAccepted,
        sceReturnedStatus: articleFilters.sceReturnedStatus,
        itemHoldout: articleFilters.itemHoldout,
      });
      if (
        response.success &&
        response?.data &&
        Array.isArray(response?.data?.data) &&
        response.data.data.length > 0
      ) {
        let newData = response.data.data || [];

        setArticles(newData);
        setTotalArticle(response.data.pagination.totalItems || 0);
        setArticlePagination((prev) => ({
          ...prev,
          totalItems: response.data.pagination.totalItems || 0,
          totalPages: response.data.pagination.totalPages || 1,
        }));
      } else {
        setArticles([]);
        setTotalArticle(0);
        setArticlePagination((prev) => ({
          ...prev,
          totalItems: 0,
          totalPages: 1,
        }));
      }
    } catch (error) {
      showToast("Failed to load articles. Please try again later.");
      setArticles([]);
      setArticlePagination((prev) => ({
        ...prev,
        totalItems: 0,
        totalPages: 1,
      }));
    } finally {
      setIsLoadingArticles(false);
    }
  }, [
    articlePagination.page,
    articlePagination.limit,
    articleFilters.searchQuery,
    articleFilters.selectedJournalIds,
    articleFilters.articleTypes,
    articleFilters.copyediting,
    articleFilters.selectedVolIss,
    articleFilters.points,
    articleFilters.preAccepted,
    articleFilters.sceReturnedStatus,
    articleFilters.itemHoldout,
    sortConfig.key,
    sortConfig.direction,
    userData.id,
    showToast,
  ]);

  const fetchIssuesData = useCallback(async () => {
    try {
      setIsLoadingIssues(true);
      const response = await fetchIssueByUnAssigned({
        page: issuePagination.page,
        limit: issuePagination.limit,
        search: issueFilters.searchQuery.trim(),
        journal: issueFilters.selectedJournalIds,
        task: issueFilters.task,
        volIss: issueFilters.selectedVolIss,
        key: sortConfig.key,
        //?? IssueHeaders[0].key,
        direction: sortConfig.direction,
        userId: userData.id,
      });

      if (
        response.success &&
        response?.data &&
        response?.data?.data?.length >= 1
      ) {
        let newData = response.data.data;

        setIssues(newData);
        setTotalIssue(response.data.pagination.totalItems || 0);
        setIssuePagination((prev) => ({
          ...prev,
          totalItems: response.data.pagination.totalItems || 0,
          totalPages: response.data.pagination.totalPages || 1,
        }));
      } else {
        setIssues([]);
        setTotalIssue(0);
        setIssuePagination((prev) => ({
          ...prev,
          totalItems: 0,
          totalPages: 1,
        }));
      }
    } catch (error) {
      showToast("Failed to load issues. Please try again later.");
      setIssues([]);
      setIssuePagination((prev) => ({
        ...prev,
        totalItems: 0,
        totalPages: 1,
      }));
    } finally {
      setIsLoadingIssues(false);
    }
  }, [
    issuePagination.page,
    issuePagination.limit,
    issueFilters.searchQuery,
    issueFilters.selectedJournalIds,
    issueFilters.task,
    issueFilters.selectedVolIss,
    sortConfig.key,
    sortConfig.direction,
    userData.id,
    showToast,
  ]);

  const LoadOnce = async () => {
    let success = false;
    const startTime = Date.now();

    if (!hasLoadedOnce) {
      setIsLoading(false);
      setLoadingState("spinning");
    }

    try {
      const tasks = [];

      if (isArticle) tasks.push(fetchArticlesData());
      if (isIssue) tasks.push(fetchIssuesData());

      await Promise.all(tasks);

      sortEffectRanRef.current = true;
      success = true;
    } catch (err) {
      showToast("Something went wrong. Please contact admin.");
    } finally {
      if (!hasLoadedOnce) {
        const timeTaken = Date.now() - startTime;

        if (timeTaken < 2000) {
          setLoadingState("data");
          setHasLoadedOnce(true);
        } else if (timeTaken >= 2000 && timeTaken < 5000) {
          setTimeout(() => {
            setLoadingState("data");
            setHasLoadedOnce(true);
          }, 2000);
        } else {
          setTimeout(() => {
            setLoadingState("skeleton");
            setTimeout(() => {
              if (!success) {
                setIsReload(true);
              } else {
                setLoadingState("data");
                setHasLoadedOnce(true);
              }
            }, 2000);
          }, 3000);
        }
      }
    }
  };

  const [contentHeight, setContentHeight] = useState(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    if (isAdditionalFilterOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const availableHeight = window.innerHeight - rect.bottom - 16;
      setContentHeight(availableHeight);
    }
  }, [isAdditionalFilterOpen]);

  useEffect(() => {
    LoadOnce();
  }, []);

  useEffect(() => {
    if (!sortEffectRanRef.current) return;
    if (activeTabRef.current === "Article") {
      fetchArticlesData();
    } else {
      fetchIssuesData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    articlePagination.page,
    articlePagination.limit,
    articleFilters.selectedJournalIds,
    articleFilters.articleTypes,
    articleFilters.copyediting,
    articleFilters.selectedVolIss,
    articleFilters.points,
    articleFilters.sceReturnedStatus,
    articleFilters.itemHoldout,
    issuePagination.page,
    issuePagination.limit,
    issueFilters.selectedJournalIds,
    issueFilters.task,
    issueFilters.selectedVolIss,
    sortConfig,
    preferences,
  ]);

  // const debouncedFetchArticles = useMemo(()=>createDebounce(fetchArticlesData, 600),[])
  // const debouncedFetchIssues = createDebounce(fetchIssuesData, 600)

  const fetchDataOnSearch = () => {
    if (!searchTriggeredRef.current) return;
    if (activeTab === "Article") {
      if (
        articleFilters.searchQuery.length > 2 ||
        !articleFilters.searchQuery.length
      ) {
        fetchArticlesData();
      }
    } else {
      if (
        issueFilters.searchQuery.length > 2 ||
        !issueFilters.searchQuery.length
      ) {
        fetchIssuesData();
      }
    }
  };

  useEffect(() => {
    if (activeTab === "Article") {
      setIsLoadingArticles(true);
    } else {
      setIsLoadingIssues(true);
    }
    const timeoutId = setTimeout(() => {
      fetchDataOnSearch();
    }, 600);
    return () => clearTimeout(timeoutId);
  }, [articleFilters.searchQuery, issueFilters.searchQuery, activeTab]);

  const fetchEligibleUsers = async () => {
    try {
      const response = await fetchUsersTaskPermission();
      const { articleUsers, issueUsers } = response?.data;
      if (response.success) {
        setArticleUsers(articleUsers);
        setIssueUsers(issueUsers);
      }
    } catch (error) {
      showToast("Failed to load users. Please try again later.");
    }
  };

  let fetchVolIssOptions = async () => {
    try {
      if (activeTabRef.current === "Article" && !isArticle) return;
      if (activeTabRef.current === "Issue" && !isIssue) return;
      let response = await fetchVolIss({
        id: null,
        type: activeTabRef.current === "Article" ? "Article" : "Issue",
        time: "",
        journal: "",
        place: "taskAssignment",
      });
      if (activeTabRef.current === "Article") {
        setVolIssOptions(response.data.data.volIss);
        setProductionWorkflowOptions(
          response?.data?.data?.productionWorkflow.filter(
            (dt) => dt.value !== "ISSUE-MANAGED" || dt.label !== "ISSUE-MANAGED"
          )
        );
        setArticleTypesOptions(response?.data?.data?.docHead);
        setJournalOptions(response?.data?.data?.journalId);
        setPointsOptions(response?.data?.data?.points);
      } else {
        setIssueJournalOptions(response?.data?.data?.journalId);
        setIssueVolIssOptions(response?.data?.data?.volIss);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchEligibleUsers();
  }, []);

  useEffect(() => {
    fetchVolIssOptions();
  }, [activeTab]);

  useEffect(() => {
    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    }
  }, [activeTab, activeTabRef.current]);

  useEffect(() => {
    if (activeTab === "Article") {
      setSortConfig({ key: null, direction: "asc" });
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
      setSortConfig({ key: null, direction: "asc" });
    } else {
      setSortConfig({
        key: null,
        // IssueHeaders[0].key
        direction: "asc",
      });
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
      setSortConfig({
        key: null,
        // IssueHeaders[0].key
        direction: "asc",
      });
    }
  }, [activeTab]);

  const TableActions = React.memo(({ row }) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const isArticleRow = "productionHandler" in row;
    const isArticleEditable =
      (userData?.articleTaskManagement || "").toLowerCase() === "edit";
    const isIssueEditable =
      (userData?.issueTaskManagement || "").toLowerCase() === "edit";
    const isEditable = isArticleRow ? isArticleEditable : isIssueEditable;
    const isAssigned = isArticleRow
      ? !!row.productionHandler
      : !!row.coverHandler &&
        !!row.finalizingHandler &&
        !!row.tocHandler &&
        !!row.webHandler;
    useEffect(() => {
      const scrollContainer = scrollContainerRef.current;
      const handleScroll = () => {
        if (isPopoverOpen) setIsPopoverOpen(false);
      };
      if (scrollContainer) {
        scrollContainer.addEventListener("scroll", handleScroll);
      }
      return () => {
        if (scrollContainer) {
          scrollContainer.removeEventListener("scroll", handleScroll);
        }
      };
    }, [isPopoverOpen]);

    useEffect(() => {
      const scrollContainer = scrollContainerRef.current;
      const handleScroll = () => {
        if (isPopoverOpen) setIsPopoverOpen(false);
      };
      if (scrollContainer) {
        scrollContainer.addEventListener("scroll", handleScroll);
      }
      return () => {
        if (scrollContainer) {
          scrollContainer.removeEventListener("scroll", handleScroll);
        }
      };
    }, [isPopoverOpen]);

    return (
      <div className="flex space-x-2 items-center">
        <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
          <PopoverTrigger asChild>
            <button
              className={`border-2 px-2  py-1 rounded-md min-text-[16px] max-text-[32px] max-w-[82px]   font-semibold transition-colors flex items-center
                  ${
                    isAssigned
                      ? "text-[#D7D9DB] border-[#D7D9DB]"
                      : isPopoverOpen
                      ? "bg-[#B8C7FE] text-[#1C40C9] border-[#1C40C9]"
                      : "text-[#1C40C9] border-[#1C40C9] hover:bg-blue-50"
                  }
                  ${
                    !isEditable
                      ? "opacity-50 text-gray-400 border-gray-400"
                      : ""
                  }`}
              onClick={() => {
                if (isEditable) setIsPopoverOpen(!isPopoverOpen);
              }}
              disabled={!isEditable}
            >
              Assign
              <i
                className={`fas fa-chevron-down ml-2 text-xs transition-transform ${
                  isPopoverOpen ? "rotate-180" : ""
                }`}
              ></i>
            </button>
          </PopoverTrigger>
          <PopoverContent
            className="w-[140px] h-[80px] text-[#35424D] bg-white border border-[#C2C6CA] rounded-md shadow-lg z-50 p-0 flex flex-col"
            align="end"
            sideOffset={5}
          >
            <div className="pt-1 pb-1">
              <button
                className="block w-full font-medium text-left px-4 h-[36px] text-[13px] text-[#35424D] hover:bg-[#E1E6FF]"
                onClick={() => {
                  handleAssignToSelf(row);
                  setIsPopoverOpen(false);
                }}
              >
                Assign to Self
              </button>
              <button
                className="block w-full font-medium text-left px-4 h-[35px] text-[13px] text-[#35424D] hover:bg-[#E1E6FF]"
                onClick={() => {
                  handleAssignToOthers(row);
                  setIsPopoverOpen(false);
                }}
              >
                Assign to Others
              </button>
            </div>
          </PopoverContent>
        </Popover>
      </div>
    );
  });

  const actions = useCallback(
    (row) => <TableActions row={row} />,
    [
      articleFilters,
      issueFilters,
      articlePagination,
      issuePagination,
      sortConfig,
    ]
  );

  const handleAssignToSelf = async (row) => {
    try {
      const isArticle = "productionHandler" in row;
      let data;
      if (isArticle) {
        const {
          journalInfo,
          volIss,
          hasChanges,
          journalId,
          ceWorkFlow,
          team,
          ...rest
        } = row;
        data = rest;
      } else {
        const { ArticleDetails, journal, volIss, team, ...rest } = row;
        data = rest;
      }

      const updatedData = {
        ...data,
        ...(isArticle
          ? { productionHandler: userData.id }
          : row.task === "Web Handling"
          ? { webHandler: userData.id }
          : row.task === "TOC Handling"
          ? { tocHandler: userData.id }
          : row.task === "Finalizing Handling"
          ? { finalizingHandler: userData.id }
          : { coverHandler: userData.id }),
      };

      let Name = "";
      let nav = "";
      updatedData.from = "taskAssignment";

      if (activeTabRef.current === "Article") {
        const today = new Date().toISOString().slice(0, 10);

        const date1 = updatedData.sdPublishedOnWebS250;
        const date2 = updatedData.sdPublishedOnWebS300;
        const date3 = updatedData.ewImportedS200;

        const hasAnyDate = date1 || date2 || date3;

        const isAllPast =
          hasAnyDate &&
          (!date1 || date1 <= today) &&
          (!date2 || date2 <= today) &&
          (!date3 || date3 <= today);

        if (isAllPast) {
          Name = "My Tasks History";
          nav = "/history";
        } else {
          Name = "My Tasks";
          nav = "/myTask";
        }
      } else {
        const today = new Date().toISOString().slice(0, 10);
        let isAllPast = updatedData.issueS300Date <= today;
        if (isAllPast) {
          Name = "My Tasks History";
          nav = "/history";
        } else {
          Name = "My Tasks";
          nav = "/myTask";
        }
      }

      const updateFunction = isArticle ? updateTaskArticle : updateTaskIssue;
      const response = await updateFunction(row.id, updatedData);

      if (response.success) {
        const message = isArticle
          ? `You're assigned as Production Handler for PTS Id: ${row.pts}. Task moved to ${Name}`
          : `You're assigned as ${row.task} for Vol/Iss Id: ${row.volIss}. Task moved to ${Name}`;

        showToast(message, [
          { text: `View ${Name}`, action: () => navigate(`${nav}`) },
          {
            text: "Undo Assignment",
            action: () => undoAssignment(row.id, row, "self"),
          },
        ]);

        setTimeout(() => {
          if (isArticle) {
            fetchArticlesData();
          } else {
            fetchIssuesData();
          }
        }, 3000);
      } else {
        throw new Error(
          response.message || "Failed to assign task to yourself"
        );
      }
    } catch (error) {
      showToast(error?.message || "Error assigning task to yourself");
    }
  };

  const handleAssignToOthers = useCallback((row) => {
    setSelectedTask(row);
    setIsAssignModalOpen(true);
  }, []);

  const confirmAssignment = async () => {
    if (!selectedUser || !selectedTask) {
      showToast("Please select a user to assign the task.");
      return;
    }

    try {
      const users = activeTab === "Article" ? articleUsers : issueUsers;
      const assignedUser = users.find((user) => user.id === selectedUser.id);

      if (!assignedUser) {
        throw new Error(
          "Selected user not found or not eligible for this task"
        );
      }

      let rest;
      if (activeTab === "Article") {
        let {
          journalInfo,
          volIss,
          hasChanges,
          journalId,
          ceWorkFlow,
          team,
          ...articleRest
        } = selectedTask;
        rest = articleRest;
      } else if (activeTab === "Issue") {
        let { ArticleDetails, journal, volIss, team, ...issueRest } =
          selectedTask;
        rest = issueRest;
      }

      const updatedData = {
        ...rest,
        ...(activeTab === "Article"
          ? { productionHandler: assignedUser.id }
          : selectedTask.task === "Web Handling"
          ? { webHandler: assignedUser.id }
          : selectedTask.task === "TOC Handling"
          ? { tocHandler: assignedUser.id }
          : selectedTask.task === "Finalizing Handling"
          ? { finalizingHandler: assignedUser.id }
          : { coverHandler: assignedUser.id }),
      };
      updatedData.from = "taskAssignment";

      const updateFunction =
        activeTab === "Article" ? updateTaskArticle : updateTaskIssue;
      const response = await updateFunction(selectedTask.id, updatedData);

      if (response.success) {
        const message =
          activeTab === "Article"
            ? `Production Handler assigned for PTS Id: ${selectedTask.pts}`
            : `${selectedTask.task} assigned for Vol/Iss Id: ${selectedTask.volIss}`;

        showToast(message, [
          {
            text: "Undo Assignment",
            action: () =>
              undoAssignment(selectedTask.id, selectedTask, "others"),
          },
        ]);

        // setTimeout(() => {
        if (activeTabRef.current === "Article") {
          fetchArticlesData();
        } else {
          fetchIssuesData();
        }
        // }, 3000);
      } else {
        throw new Error(response.message || "Failed to assign task");
      }
    } catch (error) {
      showToast(error.message || "Error assigning task");
    } finally {
      setIsAssignModalOpen(false);
      setSelectedUser("");
    }
  };

  const undoAssignment = useCallback(
    async (taskId, data, assignmentType) => {
      try {
        const isArticle = "productionHandler" in data;
        const updatedData = isArticle
          ? { productionHandler: null }
          : data.task === "Web Handling"
          ? { webHandler: null }
          : data.task === "TOC Handling"
          ? { tocHandler: null }
          : data.task === "Finalizing Handling"
          ? { finalizingHandler: null }
          : { coverHandler: null };
        updatedData.from = "taskAssignment";
        const updateFunction = isArticle ? updateTaskArticle : updateTaskIssue;
        const response = await updateFunction(taskId, updatedData);

        if (response.success) {
          setTimeout(() => {
            if (isArticle) {
              fetchArticlesData();
            } else {
              fetchIssuesData();
            }
          }, 2000);
          showToast("Assignment undone successfully");
        } else {
          throw new Error(response.message || "Failed to undo assignment");
        }
      } catch (error) {
        showToast(error.message || "Error undoing assignment");
      }
    },
    [showToast, fetchArticlesData, fetchIssuesData]
  );

  const handleJournalSelection = (selected, journalIds) => {
    let journalOption =
      activeTabRef.current === "Article" ? journalOptions : IssueJournalOptions;

    const newSelection =
      selected.includes("All") ||
      selected.length === 0 ||
      journalOption.length === selected.length
        ? ["All"]
        : selected;

    const newJournalIds =
      selected.includes("All") ||
      selected.length === 0 ||
      journalOption.length === selected.length
        ? []
        : journalIds;

    const isAllSelected =
      (Array.isArray(newSelection) &&
        newSelection.length === 1 &&
        newSelection[0] === "All") ||
      newSelection.length === 0 ||
      journalOption.length === selected.length;

    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        selectedJournals: newSelection,
        tempSelectedJournals: isAllSelected
          ? newSelection
          : newJournalIds?.map((j) => j.value),
        selectedJournalIds: newJournalIds,
      }));
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        selectedJournals: newSelection,
        tempSelectedJournals: isAllSelected
          ? newSelection
          : newJournalIds?.map((j) => j.value),
        selectedJournalIds: newJournalIds,
      }));
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
    }
  };

  const handleVolIssSelection = (selected) => {
    const newSelection =
      selected.includes("All") || selected.length === 0 ? ["All"] : selected;
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        selectedVolIss: newSelection,
      }));
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        selectedVolIss: newSelection,
      }));
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
    }
  };

  const handleTempArticleTypeChange = (type) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempArticleTypes: type,
    }));
  };

  const handleTempCopyeditingChange = (copyediting) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempCopyediting: copyediting.length >= 1 ? copyediting : ["All"],
    }));
  };

  const handleTempPoints = (points) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempPoints: points.length >= 1 ? points : ["All"],
    }));
  };

  const handleTempTaskChange = (task) => {
    setIssueFilters((prev) => ({
      ...prev,
      tempTask: task,
    }));
  };

  const handleTempPreAccepted = (val) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempPreAccepted: val,
    }));
  };

  const handleTempSceReturnedStatus = (val) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempSceReturnedStatus: prev.tempSceReturnedStatus === val ? "" : val,
    }));
  };

  const handleTempItemHoldout = (val) => {
    setArticleFilters((prev) => ({
      ...prev,
      tempItemHoldout: prev.tempItemHoldout === val ? "" : val,
    }));
  };

  const applyFilters = () => {
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        articleTypes: [...prev.tempArticleTypes],
        copyediting: [...prev.tempCopyediting],
        preAccepted: prev.tempPreAccepted,
        sceReturnedStatus: prev.tempSceReturnedStatus,
        itemHoldout: prev.tempItemHoldout,
        points: prev.tempPoints,
      }));
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        task: [...prev.tempTask],
      }));
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
    }
    setIsAdditionalFilterOpen(false);
    // setHasFilters(true);
  };

  const clearAllFilters = () => {
    if (activeTab === "Article") {
      setArticleFilters({
        searchQuery: "",
        selectedJournals: ["All"],
        selectedVolIss: ["All"],
        articleTypes: ["All"],
        copyediting: ["All"],
        tempArticleTypes: ["All"],
        tempCopyediting: ["All"],
        tempSelectedJournals: ["All"],
        selectedJournalIds: [],
        preAccepted: false,
        tempPreAccepted: false,
        sceReturnedStatus: "",
        tempSceReturnedStatus: "",
        itemHoldout: "",
        tempItemHoldout: "",
        points: ["All"],
        tempPoints: ["All"],
      });
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      setIssueFilters({
        searchQuery: "",
        selectedJournals: ["All"],
        selectedVolIss: ["All"],
        tempSelectedJournals: ["All"],
        task: [],
        tempTask: [],
        selectedJournalIds: [],
      });
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
    }
    setHasFilters(false);
    setIssueCursor(null);
    setPrevCursor(null);
  };

  const handleRemoveFilter = (filterKey, value) => {
    if (activeTab === "Article") {
      switch (filterKey) {
        case "searchTerm":
          setArticleFilters((prev) => ({ ...prev, searchQuery: "" }));
          break;
        case "selectedJournals":
          handleJournalSelection(
            articleFilters.selectedJournals.filter((j) => j !== value),
            articleFilters.selectedJournalIds.filter((j) => j.label !== value)
          );
          break;
        case "selectedVolIss":
          handleVolIssSelection(
            articleFilters.selectedVolIss.filter((v) => v !== value)
          );
          break;
        case "selectedArticleTypes":
          setArticleFilters((prev) => {
            const updated = prev.articleTypes.filter((t) => t !== value);
            return {
              ...prev,
              articleTypes: updated.length > 0 ? updated : ["All"],
              tempArticleTypes: updated.length > 0 ? updated : ["All"],
            };
          });
          break;

        case "selectedPoints":
          setArticleFilters((prev) => {
            const updated = prev.points.filter((t) => t !== value);
            return {
              ...prev,
              points: updated.length > 0 ? updated : ["All"],
              tempPoints: updated.length > 0 ? updated : ["All"],
            };
          });
          break;

        case "selectedCopyediting":
          setArticleFilters((prev) => {
            const updated = prev.copyediting.filter((c) => c !== value);
            return {
              ...prev,
              copyediting: updated.length > 0 ? updated : ["All"],
              tempCopyediting: updated.length > 0 ? updated : ["All"],
            };
          });
          break;

        case "selectedSceReturnedStatus":
          setArticleFilters((prev) => ({
            ...prev,
            sceReturnedStatus: "",
            tempSceReturnedStatus: "",
          }));
          break;
        case "selectedItemHoldout":
          setArticleFilters((prev) => ({
            ...prev,
            itemHoldout: "",
            tempItemHoldout: "",
          }));
          break;
        default:
          break;
      }
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      switch (filterKey) {
        case "searchTerm":
          setIssueFilters((prev) => ({ ...prev, searchQuery: "" }));
          break;
        case "selectedJournals":
          handleJournalSelection(
            issueFilters.selectedJournals.filter((j) => j !== value),
            issueFilters.selectedJournalIds.filter((j) => j.label !== value)
          );
          break;
        case "selectedVolIss":
          handleVolIssSelection(
            issueFilters.selectedVolIss.filter((v) => v !== value)
          );
          break;
        case "selectedTask":
          setIssueFilters((prev) => ({
            ...prev,
            task: prev.task.filter((t) => t !== value),
            tempTask: prev.tempTask.filter((t) => t !== value),
          }));
          break;
        default:
          break;
      }
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
      setIssueCursor(null);
      setPrevCursor(null);
    }
  };

  const handleClearAllFilters = () => {
    clearAllFilters();
  };

  const handleAdvancedClearFilter = () => {
    if (activeTabRef.current === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        tempArticleTypes: ["All"],
        tempCopyediting: ["All"],
        tempPreAccepted: false,
        tempSceReturnedStatus: "",
        tempItemHoldout: "",
        tempPoints: ["All"],
      }));
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        tempTask: [],
      }));
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
    }
    setHasFilters(false);
  };

  const currentFilters =
    activeTab === "Article" ? articleFilters : issueFilters;

  const filters = {
    searchTerm:
      currentFilters.searchQuery.length >= 3
        ? currentFilters.searchQuery
        : null,
    selectedJournals: currentFilters.selectedJournals.includes("All")
      ? null
      : currentFilters.selectedJournalIds.map((journal) => journal.label),
    selectedVolIss: currentFilters.selectedVolIss.includes("All")
      ? null
      : currentFilters.selectedVolIss,
    ...(activeTab === "Article"
      ? {
          selectedArticleTypes:
            currentFilters.articleTypes.length > 0
              ? currentFilters.articleTypes
              : null,
          selectedCopyediting:
            currentFilters.copyediting.length > 0
              ? currentFilters.copyediting
              : null,
          selectedPoints:
            currentFilters.points.length > 0 ? currentFilters.points : null,
          selectedSceReturnedStatus:
            currentFilters.sceReturnedStatus !== ""
              ? currentFilters.sceReturnedStatus
              : null,
          selectedItemHoldout:
            currentFilters.itemHoldout !== ""
              ? currentFilters.itemHoldout
              : null,
        }
      : {
          selectedTask:
            currentFilters.task.length > 0 ? currentFilters.task : null,
        }),
  };

  const getFilterLabel = useCallback(
    (selectedItems, defaultLabel, options = []) => {
      if (selectedItems.includes("All") || selectedItems.length === 0) {
        return `${defaultLabel}: All`;
      }
      const selectedLabels = selectedItems.map((item) => {
        const option = options.find((opt) => opt.value === item);
        return option ? option.label : item;
      });
      if (selectedLabels.length === 1) {
        return `${defaultLabel}: ${selectedLabels[0]}`;
      }
      return `${defaultLabel}: ${selectedLabels[0]} + more`;
    },
    []
  );

  const handlePageChange = (newPage) => {
    if (activeTab === "Article") {
      setArticlePagination((prev) => ({ ...prev, page: newPage }));
    } else {
      setIssuePagination((prev) => ({ ...prev, page: newPage }));
    }
  };

  const handleItemsPerPageChange = (newLimit) => {
    if (activeTab === "Article") {
      setArticlePagination((prev) => ({
        ...prev,
        limit: newLimit,
        page: 1,
      }));
    } else {
      setIssuePagination((prev) => ({
        ...prev,
        limit: newLimit,
        page: 1,
      }));
    }
  };

  const handleSearchChange = (e) => {
    searchTriggeredRef.current = true;
    const value = e.target.value;
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({ ...prev, searchQuery: value }));
      setArticlePagination((prev) => ({ ...prev, page: 1 }));
    } else {
      setIssueFilters((prev) => ({ ...prev, searchQuery: value }));
      setIssuePagination((prev) => ({ ...prev, page: 1 }));
    }
  };

  useEffect(() => {
    if (
      (activeTab === "Article" &&
        ((currentFilters.copyediting.length > 0 &&
          !currentFilters.copyediting.includes("All")) ||
          (currentFilters.points.length > 0 &&
            !currentFilters.points.includes("All")) ||
          currentFilters.preAccepted ||
          currentFilters.itemHoldout === false ||
          currentFilters.itemHoldout === true ||
          currentFilters.sceReturnedStatus === false ||
          currentFilters.sceReturnedStatus === true)) ||
      (activeTab === "Issue" && currentFilters.task.length > 0)
    ) {
      setHasFilters(true);
    } else {
      setHasFilters(false);
    }
  }, [currentFilters, activeTab]);

  let HandleClearSearch = () => {
    if (activeTab === "Article") {
      setArticleFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    } else {
      setIssueFilters((prev) => ({
        ...prev,
        searchQuery: "",
      }));
    }
  };

  const ArticleSections = [
    {
      label: "Production workflow",
      key: "productionWorkflow",
      values: productionWorkflowOptions,
    },
    {
      label: "Include pre accepted",
      key: "preAcceptDate",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      label: "SCE returned status",
      key: "sceReturnedStatus",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  ];

  const ArticleTempValues = useMemo(
    () => ({
      productionWorkflow: articleFilters.tempCopyediting,
      preAcceptDate: articleFilters.tempPreAccepted,
      sceReturnedStatus: articleFilters.tempSceReturnedStatus,
    }),
    [
      articleFilters.tempCopyediting,
      articleFilters.tempPreAccepted,
      articleFilters.tempSceReturnedStatus,
    ]
  );

  const ArticleTempSetValues = useMemo(
    () => ({
      productionWorkflow: handleTempCopyeditingChange,
      preAcceptDate: handleTempPreAccepted,
      sceReturnedStatus: handleTempSceReturnedStatus,
    }),
    [
      handleTempCopyeditingChange,
      handleTempPreAccepted,
      handleTempSceReturnedStatus,
    ]
  );

  const handleUpdateTask = async (updatedTask) => {
    try {
      let updateFunction =
        activeTabRef.current === "Article"
          ? updateTaskArticle
          : updateTaskIssue;

      updatedTask.from = "taskAssignment";

      const response = await updateFunction(updatedTask.id, updatedTask);

      if (response.success) {
        showToast("Task updated successfully");
        handleCloseForm();
      } else {
        showToast(response.message || "Failed to update task");
      }
    } catch (error) {
      console.error("Error updating task:", error);
      showToast("Error updating task: " + error.message);
    } finally {
      if (activeTabRef.current === "Article") {
        await fetchArticlesData();
      } else {
        await fetchIssuesData();
      }
    }
  };

  const handleCloseForm = () => {
    setSelectedTask(null);
    setOpenForm(false);
    setActiveRowId(null);
  };

  const fetchUsersList = async () => {
    const response = await fetchUserForForm();
    if (response.success) {
      const { userNames, userOptions } = response?.data;
      setUserOption(userNames);
      setObjectUserOption(userOptions);
    }
  };

  async function onRowSelect(task) {
    setOpenForm(true);
    try {
      let newTask = task;
      if (activeTabRef.current === "Issue") {
        const issue = await fetchIssueById(task.id);
        if (issue.success && issue?.data) {
          newTask = issue?.data;
          setSelectedFieldConfiguration(
            newTask?.ArticleDetails?.[0]?.journalInfo?.fieldConfiguration
          );
        }
      } else {
        setSelectedFieldConfiguration(task?.journalInfo?.fieldConfiguration);
      }
      setSelectedTask(newTask);
      await fetchUsersList();
    } catch (error) {
      showToast(error.message ?? "Something went wrong");
    }
  }

  const IssueSection = [
    {
      label: "Task",
      key: "task",
      values: [
        { value: "coverHandler", label: "Cover handling" },
        { value: "tocHandler", label: "TOC handling" },
        { value: "webHandler", label: "Web handling" },
        { value: "finalizingHandler", label: "Finalizing handling" },
      ],
    },
  ];

  const IssueTempValues = {
    task: issueFilters.tempTask,
  };

  const IssueSetTempValues = {
    task: handleTempTaskChange,
  };

  const sections =
    activeTabRef.current === "Article" ? ArticleSections : IssueSection;
  const tempSelected =
    activeTabRef.current === "Article" ? ArticleTempValues : IssueTempValues;
  const setTempSelected =
    activeTabRef.current === "Article"
      ? ArticleTempSetValues
      : IssueSetTempValues;

  return loadingState === "spinning" ? (
    <div className="flex items-center justify-center h-full">
      <Spinner />
    </div>
  ) : loadingState === "skeleton" ? (
    <PageSkeletons />
  ) : (
    <div
      className="bg-gray-100 flex flex-col"
      style={{
        fontFamily: "Source Sans Pro",
        height: "calc(100vh - 80px)",
      }}
    >
      <div className="flex-1 p-6 bg-white flex flex-col h-full">
        {!openForm && (
          <>
            <div className="header-section shrink-0 bg-white sticky top-0">
              <div className="flex items-center justify-start mb-3 space-x-1">
                <p className="text-[#868E94] font-medium text-[13px]">
                  {active}
                </p>{" "}
                <MdOutlineKeyboardArrowRight className="text-[#5D6871] text-[16px]" />{" "}
                <p className="text-[#5D6871] font-medium text-[13px]">
                  {activeTabRef.current}
                </p>
              </div>
              <div className="flex justify-between items-center mb-2">
                <h1 className="text-[#20282E] text-[23px] h-[32px] font-semibold">
                  {active}
                </h1>
                <div className="text-[11px] font-medium h-[14px] w-[165px] text-[#35424D] flex items-center">
                  <DataSyncError />
                  Last Sync: {dataSyncTime?.value}
                  <br></br>
                  {/* {dataSyncTime?.value ? "Snowflake data not available." : ""} */}
                </div>
              </div>

              <div className="flex items-center justify-between border-b-2 border-gray-200 mb-3">
                <div className="flex">
                  <button
                    disabled={!isArticle}
                    className={`p-3 flex items-center h-[28px] ${
                      activeTab === "Article"
                        ? "border-b-2 border-[#1C40C9] text-[13px] text-[#35424D] font-semibold"
                        : "font-medium hover:text-[#35424D] text-[13px]"
                    }`}
                    onClick={() => {
                      if (isArticle) {
                        setActiveTab("Article");
                      }
                    }}
                  >
                    Article ({totalArticle})
                  </button>
                  <button
                    disabled={!isIssue}
                    className={`p-3 flex items-center h-[28px] ${
                      activeTab === "Issue"
                        ? "border-b-2 border-[#1C40C9] text-[13px] text-[#35424D] font-semibold"
                        : "font-medium hover:text-[#35424D] text-[13px]"
                    }`}
                    onClick={() => {
                      if (isIssue) {
                        setActiveTab("Issue");
                      }
                    }}
                  >
                    Issue ({totalIssue})
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="relative w-[246px]">
                  <input
                    type="text"
                    className={`border rounded-[4px] w-[246px] h-[32px] py-[4px] px-[12px] pr-[32px] text-sm transition-colors ${
                      isFocused
                        ? " focus:border-[#35424D] focus:border focus:outline-none"
                        : "border-[#C3C3C3]"
                    }`}
                    placeholder="Search"
                    maxLength={100}
                    value={currentFilters.searchQuery}
                    onChange={handleSearchChange}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() =>
                      currentFilters.searchQuery === "" && setIsFocused(false)
                    }
                  />
                  {(!isFocused || currentFilters.searchQuery.length === 0) && (
                    <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3]" />
                  )}
                  {currentFilters.searchQuery.length > 0 && (
                    <FaTimes
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3] cursor-pointer"
                      onClick={() => {
                        if (activeTab === "Article") {
                          setArticleFilters((prev) => ({
                            ...prev,
                            searchQuery: "",
                          }));
                          setArticlePagination((prev) => ({
                            ...prev,
                            page: 1,
                          }));
                          setIsLoadingArticles(true);
                        } else {
                          setIssueFilters((prev) => ({
                            ...prev,
                            searchQuery: "",
                          }));
                          setIssuePagination((prev) => ({
                            ...prev,
                            page: 1,
                          }));
                          setIsLoadingIssues(true);
                        }
                      }}
                    />
                  )}
                </div>

                <div className="flex items-center gap-2">
                  <Popover
                    open={showSortOptions}
                    onOpenChange={setShowSortOptions}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          showSortOptions ? "bg-[#D9D9D9]" : ""
                        }`}
                      >
                        <span className="text-[#35424D] text-[13px] font-semibold flex items-center gap-1">
                          Sort by:
                          <span className="flex items-center font-medium gap-1">
                            {sortConfig.direction === "asc" ? (
                              <FaArrowUp className="text-[#35424D] h-[12px]" />
                            ) : sortConfig.direction === "desc" ? (
                              <FaArrowDown className="text-[#35424D] h-[12px]" />
                            ) : null}
                            {(() => {
                              const headers =
                                activeTab === "Article"
                                  ? ArticleHeaders
                                  : IssueHeaders;

                              if (!sortConfig.key) return "";

                              const match = headers.find((h) => {
                                const headerKeyLast = h.key.includes(".")
                                  ? h.key.split(".").pop()
                                  : h.key;
                                const sortKeyLast = sortConfig.key.includes(".")
                                  ? sortConfig.key.split(".").pop()
                                  : sortConfig.key;
                                return headerKeyLast === sortKeyLast;
                              });

                              return match?.value || "";
                            })()}
                          </span>
                        </span>
                        <i
                          className={`fas fa-chevron-down text-xs ${
                            showSortOptions ? "transform rotate-180" : ""
                          }`}
                        ></i>
                      </button>
                    </PopoverTrigger>
                    <PopoverContent>
                      <SortDropdown
                        headers={
                          activeTab === "Article"
                            ? ArticleHeaders
                            : IssueHeaders
                        }
                        activeTab={activeTab}
                        sortConfig={sortConfig}
                        isOpen={showSortOptions}
                        setSortConfig={setSortConfig}
                        setShowSortOptions={setShowSortOptions}
                      />
                    </PopoverContent>
                  </Popover>

                  <Popover
                    open={isJournalFilterOpen}
                    onOpenChange={setIsJournalFilterOpen}
                  >
                    <PopoverTrigger asChild>
                      <button
                        className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                          isJournalFilterOpen ? "bg-[#D9D9D9]" : ""
                        }`}
                      >
                        <span className="text-[#35424D] text-[13px]">
                          <span className="font-semibold">Journal</span>{" "}
                          <span className="font-medium">
                            {getFilterLabel(
                              currentFilters.selectedJournals,
                              "",
                              journalOptions
                            ).replace(/^Journal:\s*/, "")}
                          </span>
                        </span>
                        <i
                          className={`fas fa-chevron-down text-xs ${
                            isJournalFilterOpen ? "transform rotate-180" : ""
                          }`}
                        ></i>
                      </button>
                    </PopoverTrigger>
                    <PopoverContent>
                      <DropdownCheckbox
                        options={
                          activeTabRef.current
                            ? journalOptions
                            : IssueJournalOptions
                        }
                        selectedValues={currentFilters.tempSelectedJournals}
                        onSelectionChange={handleJournalSelection}
                        selectAllText="All"
                        clearAllText="Clear all"
                        type="Journal"
                        isOpen={isJournalFilterOpen}
                        label={true}
                        applyText="Apply"
                        searchPlaceholder="Search journals..."
                        onClose={() => setIsJournalFilterOpen(false)}
                        SetSelectedValuesId={
                          activeTab === "Article"
                            ? (ids) =>
                                setArticleFilters((prev) => ({
                                  ...prev,
                                  tempSelectedJournals:
                                    ids.length >= 1 &&
                                    journalOptions.length !== ids.length
                                      ? ids?.map((id) => id?.value)
                                      : ["All"],
                                  selectedJournalIds:
                                    ids.length >= 1 &&
                                    journalOptions.length !== ids.length
                                      ? ids
                                      : [],
                                }))
                            : (ids) =>
                                setIssueFilters((prev) => ({
                                  ...prev,
                                  tempSelectedJournals:
                                    ids.length >= 1
                                      ? ids?.map((id) => id?.value)
                                      : ["All"],
                                  selectedJournalIds:
                                    ids.length >= 1 &&
                                    IssueJournalOptions.length !== ids.length
                                      ? ids
                                      : [],
                                }))
                        }
                      />
                    </PopoverContent>
                  </Popover>
                  {/* {activeTabRef.current === "Issue" && (
                    <Popover
                      open={showVolIssOptions}
                      onOpenChange={setShowVolIssOptions}
                    >
                      <PopoverTrigger asChild>
                        <button
                          className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                            showVolIssOptions ? "bg-[#D9D9D9]" : ""
                          }`}
                        >
                          <span className="text-[#35424D] text-[13px]">
                            <span className="font-semibold">Vol/Iss:</span>{" "}
                            <span className="font-medium">
                              {currentFilters.selectedVolIss.includes("All")
                                ? "All"
                                : `${currentFilters.selectedVolIss[0]}${
                                    currentFilters.selectedVolIss.length > 1
                                      ? " + more"
                                      : ""
                                  }`}
                            </span>
                          </span>
                          <i
                            className={`fas fa-chevron-down text-xs ${
                              showVolIssOptions ? "rotate-180" : ""
                            }`}
                          />
                        </button>
                      </PopoverTrigger>
                      <PopoverContent>
                        <DropdownCheckbox
                          options={
                            activeTabRef.current
                              ? volIssOptions
                              : IssueVolIssOptions
                          }
                          selectedValues={currentFilters.selectedVolIss}
                          onSelectionChange={handleVolIssSelection}
                          selectAllText="All"
                          clearAllText="Clear all"
                          applyText="Apply"
                          searchPlaceholder="Search vol/Iss..."
                          onClose={() => setShowVolIssOptions(false)}
                        />
                      </PopoverContent>
                    </Popover>
                  )} */}

                  <Popover
                    open={isAdditionalFilterOpen}
                    onOpenChange={(open) => {
                      setIsAdditionalFilterOpen(open);
                      if (!open) {
                        // Reset nested popover states when main popover closes
                        setProductionWorkflowOpen(false);
                      }
                      if (open) {
                        if (activeTab === "Article") {
                          setArticleFilters((prev) => ({
                            ...prev,
                            tempArticleTypes: [...prev.articleTypes],
                            tempCopyediting: [...prev.copyediting],
                            tempPreAccepted: prev.preAccepted,
                            tempSceReturnedStatus: prev.sceReturnedStatus,
                            tempItemHoldout: prev.itemHoldout,
                          }));
                        } else {
                          setIssueFilters((prev) => ({
                            ...prev,
                            tempTask: [...prev.task],
                          }));
                        }
                      }
                    }}
                  >
                    <PopoverTrigger ref={triggerRef} asChild>
                      <button
                        className={`flex items-center justify-center p-2 w-[32px] h-[32px] rounded-md ${
                          isAdditionalFilterOpen
                            ? "border-[#1C40C9] bg-[#B8C7FF] hover:bg-[#E1E6FF]"
                            : "hover:bg-[#E1E6FF]"
                        }`}
                      >
                        <div className="relative">
                          <MdOutlineFilterAlt className="text-[#1C40C9] h-[15px] w-[15px]" />
                          {hasFilters && (
                            <span className="absolute top-[-2px] right-[-2px] h-[6px] w-[6px] bg-red-500 rounded-full"></span>
                          )}
                        </div>
                      </button>
                    </PopoverTrigger>
                    <DynamicFilterPopover
                      sections={sections}
                      tempSelected={tempSelected}
                      setTempSelected={setTempSelected}
                      clearAllFilters={handleAdvancedClearFilter}
                      applyFilters={applyFilters}
                      maxHeight={contentHeight}
                      type={
                        activeTabRef.current === "Article" ? "Article" : "Issue"
                      }
                      productionWorkflowOpen={productionWorkflowOpen}
                      setProductionWorkflowOpen={setProductionWorkflowOpen}
                    />
                  </Popover>
                </div>
              </div>

              {currentFilters.searchQuery.length >= 3 && (
                <p className="mt-1 mb-4 text-sm text-gray-600">
                  Showing search results:{" "}
                  <span className="text-black italic">
                    '{currentFilters.searchQuery}'
                  </span>
                </p>
              )}

              {(currentFilters.searchQuery.length >= 3 ||
                !currentFilters.selectedJournals.includes("All") ||
                !currentFilters.selectedVolIss.includes("All") ||
                (activeTab === "Article" &&
                  (currentFilters.articleTypes.length > 0 ||
                    currentFilters.copyediting.length > 0 ||
                    currentFilters.points.length > 0 ||
                    currentFilters.sceReturnedStatus !== "" ||
                    currentFilters.itemHoldout !== "")) ||
                (activeTab === "Issue" && currentFilters.task.length > 0)) && (
                <FilterChips
                  activeTab={activeTab}
                  searchValue={currentFilters.searchQuery}
                  filters={filters}
                  onRemoveFilter={handleRemoveFilter}
                  onClearAll={handleClearAllFilters}
                  chipClassName="custom-chip-class"
                  labelClassName="custom-label-class"
                  clearAllClassName="custom-clear-all-class"
                  getFilterLabel={getFilterLabel}
                  journalOptions={journalOptions}
                  taskOptions={IssueSection[0]?.values || []}
                />
              )}
            </div>

            <div
              ref={scrollContainerRef}
              className={`overflow-y-auto relative ${
                hasTasks ? "border border-[#DCDCDC] rounded-md" : "flex-1"
              }`}
            >
              {(showInitialLoading ||
                ((isLoadingArticles || isLoadingIssues) && !hasTasks)) && (
                <div className="flex flex-col items-center justify-center h-3/4">
                  <Spinner />
                </div>
              )}

              {!hasTasks &&
                !showInitialLoading &&
                !searchQuery &&
                !isLoadingArticles &&
                !isLoadingIssues && (
                  <div className="flex flex-col items-center justify-center h-3/4">
                    <img
                      src={activeTab === "Article" ? NoArticle : NoIssues}
                      className="w-[72px] h-[75px] mb-2"
                      alt="No tasks"
                    />
                    <h3 className="text-[27px] text-[#35424D] font-semibold mb-2 h-[34px]">
                      {active === "My Task"
                        ? "You have no assigned tasks!"
                        : "No pending tasks for assignment!"}
                    </h3>
                    <p className="text-[#5D6871] text-[16px] font-medium mb-6">
                      {active === "My Task"
                        ? "There are no tasks assigned to you at the moment."
                        : `There are no ${activeTab.toLowerCase()}s for assignment at the moment.`}
                    </p>
                    {active !== "My Task" && (
                      <button
                        className="text-[#1C40C9] text-[13px] font-medium"
                        onClick={() => navigate("/myTask")}
                      >
                        View My Task
                      </button>
                    )}
                  </div>
                )}

              {!showInitialLoading &&
                (hasTasks || searchQuery) &&
                !(isLoadingArticles && !hasTasks) &&
                !(isLoadingIssues && !hasTasks) && (
                  <div>
                    <CustomTable
                      data={
                        activeTabRef.current === "Article" ? articles : issues
                      }
                      actions={actions}
                      headers={
                        activeTabRef.current === "Article"
                          ? ArticleHeaders
                          : IssueHeaders
                      }
                      searchTerm={currentFilters.searchQuery.trim()}
                      setSearchTerm={HandleClearSearch}
                      setLoading={
                        activeTab === "Article"
                          ? setIsLoadingArticles
                          : setIsLoadingIssues
                      }
                      activeTab={activeTab}
                      sortConfig={sortConfig}
                      setSortConfig={setSortConfig}
                      setActiveRowId={setActiveRowId}
                      activeRowId={activeRowId}
                    />
                  </div>
                )}
            </div>

            {hasTasks && (
              <div className="shrink-0 mt-auto sticky bottom-0 bg-white">
                <Pagination
                  currentPage={
                    activeTab === "Article"
                      ? articlePagination.page
                      : issuePagination.page
                  }
                  totalPages={
                    activeTab === "Article"
                      ? articlePagination.totalPages
                      : issuePagination.totalPages
                  }
                  totalItems={
                    activeTab === "Article"
                      ? articlePagination.totalItems
                      : issuePagination.totalItems
                  }
                  itemsPerPage={
                    activeTab === "Article"
                      ? articlePagination.limit
                      : issuePagination.limit
                  }
                  onPageChange={handlePageChange}
                  onItemsPerPageChange={handleItemsPerPageChange}
                  setDirection={activeTab !== "Article" ? setDirection : null}
                />
              </div>
            )}

            {isAssignModalOpen && (
              <AssignmentModal
                onClose={() => {
                  setIsAssignModalOpen(false);
                  setSelectedUser("");
                }}
                users={activeTab === "Article" ? articleUsers : issueUsers}
                selectedTask={selectedTask}
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                confirmAssignment={confirmAssignment}
                activeTab={activeTab}
              />
            )}
          </>
        )}
        {selectedTask && activeTabRef.current === "Issue" && openForm && (
          <div className="flex flex-col h-full">
            <IssueDetails
              text="Task Assignment (Issue)"
              formdata={selectedTask}
              onSave={handleUpdateTask}
              Onclose={handleCloseForm}
              fieldConfig={selectedFieldConfig}
              userOption={userOption}
              optionsMap={objectUserOption}
            />
          </div>
        )}
        {selectedTask && activeTabRef.current === "Article" && openForm && (
          <div className="flex flex-col h-full">
            <ArticleForm
              text="Task Assignment (Article)"
              initialData={selectedTask}
              onSave={handleUpdateTask}
              onCancel={handleCloseForm}
              onback={handleCloseForm}
              fieldConfiguration={selectedFieldConfig}
              productionHandlers={objectUserOption}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskAssignmentPage;
